import { requisitarJson } from '../../../shared/api/http';

export type TipoDeOcorrencia = 'login_recusado' | 'sessao_revogada' | 'apuracao_pendente' | 'tablet_offline';
export type Criticidade = 'critica' | 'atencao';

export interface Ocorrencia {
    id: string;
    tipo: TipoDeOcorrencia;
    criticidade: Criticidade;
    /** A frase do cartão, montada no servidor ("Tablet T053 offline há 2 min."). */
    titulo: string;
    em: string;
    grupo_id: string | null;
    grupo_nome: string | null;
    fase: string | null;
    fase_rotulo: string | null;
    matricula: string | null;
    nome: string | null;
    tablet: string | null;
}

export interface OcorrenciasDaTurma {
    turma_id: string;
    grupos: { id: string; nome: string | null }[];
    /** Da mais recente para a mais antiga, nas últimas 24 h (`DP-RA-021`). */
    ocorrencias: Ocorrencia[];
}

export function listarOcorrencias(turmaId: string): Promise<OcorrenciasDaTurma> {
    return requisitarJson(`/api/v1/ocorrencias?turma_id=${encodeURIComponent(turmaId)}`);
}
